import { createStore } from 'vuex'
import createPersistedState from "vuex-persistedstate";

import auth from 'Store/module/auth'
import global from 'Store/module/global'
import invoice from 'Store/module/invoice'
import invoicePackage from 'Store/module/invoicePackage'

import keyStore, { notificationType, invoiceKeyStore, invoicePackageKeyStore } from 'Store/keyStore'

const modules = {
  auth,
  global,
  invoice,
  invoicePackage
}

const store = createStore({
  plugins: [createPersistedState()],
  modules: modules
});

export default store;

export {
  keyStore,
  notificationType,
  invoiceKeyStore,
  invoicePackageKeyStore
}
  
